export default "__VITE_ASSET__BGHJ14$k__"